import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ScaleHandler from '../../../../shared/components/ScaledSlider/impl/ScaleHandler'

import ValidationInput from '../../../../shared/components/ValidationInput/ValidationInput'
import ScaledSlider from '../../../../shared/components/ScaledSlider/ScaledSlider'
import RadialIndicator from '../../../../shared/components/RadialIndicator/RadialIndicator'

import { Formatting } from '../../../../shared/utils/Formatting';

const scaleHandler = new ScaleHandler();

const fieldRenderOrderByBreakdown = {
    category: [
        'wine',
        'beer',
        'spirits',
        'total'
    ],
    total: [
        'total'
    ]
};
const colorByField = {
    wine: 'rgba(154, 96, 117, 1)',
    beer: 'rgba(255, 185, 64, 1)',
    spirits: 'rgba(131, 193, 184, 1)',
    total: '#42434B'
};

export class DataSetSection extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        return (this.props.index !== nextProps.index) ||
               (this.props.setName !== nextProps.setName) ||
               (this.props.setData !== nextProps.setData) ||
               (this.props.showSumRadialGraphic != nextProps.showSumRadialGraphic);
    }

    render() {
        const {
            index,
            setName,
            setData,
            breakdownIndicatorClickHandlerGenerator,
            textInputChangeHandlerGenerator,
            textInputBlurHandlerGenerator,
            sliderInputChangeHandlerGenerator,
            formattingFunction,
            showSumRadialGraphic
        } = this.props;

        const activeBreakdown = setData.activeBreakdown;

        let breakdownToggles = [];
        for (let breakdown in setData.fieldsByBreakdown) {
            if (setData.fieldsByBreakdown.hasOwnProperty(breakdown)) {
                let styling = {};
                if (breakdown === activeBreakdown) {
                    styling['color'] = '#4660EA';
                    styling['borderBottom'] = '3px solid #4660EA';
                }
                breakdownToggles.push(
                    <div
                        className="toggle-button"
                        style={ styling }
                        key={ breakdown }
                        onClick={ breakdownIndicatorClickHandlerGenerator(breakdown) }
                    >
                        Report&nbsp;by&nbsp;{ Formatting.capitalizeFirstCharacter(breakdown) }
                    </div>
                )
            }
        }

        const activeBreakdownData = setData.fieldsByBreakdown[activeBreakdown];

        let activeBreakdownMessaging;
        if (activeBreakdown == 'total') {
            activeBreakdownMessaging = (
                <div className="bar-profit-caption">
                    Hey!
                    You can report by your total if you don’t know your category-specific numbers, but you’ll get a more
                    accurate and in-depth report by telling us the category numbers instead.
                </div>
            );
        } else {
            activeBreakdownMessaging = '';
        }

        const activeBreakdownValuesByField = activeBreakdownData.valuesByField;

        let totalValue = 0;
        if (showSumRadialGraphic) {
            for (let field in activeBreakdownValuesByField) {
                if (activeBreakdownValuesByField.hasOwnProperty(field)) {
                    totalValue += activeBreakdownValuesByField[field].value;
                }
            }
        }

        const fieldInputs = [];
        const fillPercentsAndColors = (totalValue === 0) ? [{fillPercent: 100}] : [];
        const fieldRenderOrder = fieldRenderOrderByBreakdown[activeBreakdown];
        for (let i = 0; i < fieldRenderOrder.length; i++) {
            const field = fieldRenderOrder[i];

            if (Object.keys(activeBreakdownValuesByField).indexOf(field) !== -1) {
                const fieldData = activeBreakdownValuesByField[field];

                fieldInputs.push(
                    <div className={ activeBreakdown == 'total' ? 'row total-slider' : 'row pad-tp-xs' } key={ field }>
                        <div className={ (setName === 'pourCostPercent' && field === 'total' && activeBreakdown != 'total') ? "bar-profit-total-caption" : "" }>

                            {(setName === 'pourCostPercent' && field === 'total' && activeBreakdown != 'total') ?
                                <div className="col-xs-12 bar-profit-caption">
                                    <div className="caption-rule">
                                        Hey—make sure you fill out the total for this section, too; it’s an independent number from the categories.
                                    </div>
                                </div> : ""
                            }

                            <div className="col-xs-4 pad-tp-xs category-label slider-label light-text">
                                { Formatting.capitalizeFirstCharacter(field) }
                            </div>

                            <div className="col-xs-5 col-xs-offset-3 slider-input-pad">
                                <ValidationInput
                                    inputClassName={ "light-text text-right" }
                                    label={ "" }
                                    value={ fieldData.text }
                                    autoFocus={ false }
                                    isValid={ fieldData.isValid }
                                    errorMessage={ fieldData.errorMessage }
                                    handleEnterClick={ function(event) {
                                        event.target.blur()
                                    }}
                                    handleChange={ textInputChangeHandlerGenerator(activeBreakdown, field) }
                                    handleBlur={ textInputBlurHandlerGenerator(activeBreakdown, field) }
                                />
                            </div>

                            <div className="col-xs-12">
                                <ScaledSlider
                                    additionalClassName={ field + "-slider" }
                                    ticks={ activeBreakdownData.scaledSliderTicks }
                                    scaleHandler={ scaleHandler }
                                    value={ fieldData.value }
                                    handleChange={ sliderInputChangeHandlerGenerator(activeBreakdown, field) }
                                    formattingFunction={ formattingFunction }
                                />
                            </div>

                            {(setName === 'pourCostPercent' && activeBreakdown == 'category' && field === 'total') ?
                                <div className="col-xs-12 bar-profit-caption">
                                    Note that your total doesn't necessarily have to be the average of the categories. Since
                                    every bar will have a unique customer base, one category might be a greater volume of the
                                    total. Here, we’d like to know your best approximation of overall pour cost.
                                </div> : ""
                            }
                        </div>
                    </div>
                );


                if (showSumRadialGraphic) {
                    if (totalValue !== 0) {
                        fillPercentsAndColors.push({
                            fillPercent: activeBreakdownValuesByField[field].value * 100 / totalValue,
                            color: colorByField[field],
                        })
                    }
                }
            }
        }

        return (
            <div>
                <div className="bar-profit-question-wrapper container">
                    <div className="row">
                        <div className="bar-profit-question col-xs-12 col-sm-5 text-right col-sm-push-7">
                            <div className="bar-profit-number text-center">{ index.toString() }</div>
                        </div>
                        <div className="bar-profit-question col-xs-12 col-sm-7 col-sm-pull-5">
                            <div className="bar-profit-subtitle">{ setData.sectionCopy.section }</div>
                            <span>{ setData.sectionCopy.title }</span>
                        </div>
                    </div>
                    <div className="row spc-tp-xs">
                        <div className="bar-profit-question-description col-xs-12 col-sm-7">
                            <span>{ setData.sectionCopy.description }</span>
                        </div>
                        <div className="col-xs-12 col-sm-5">
                        </div>
                    </div>
                </div>

                <div className="bar-profit-breakdown-toggles container">
                    { breakdownToggles }
                </div>

                <div className="bar-profit-inputs-wrapper">
                    <div className="container bar-profit-inputs-container">
                        <div className="row">
                            <div className="field-inputs-wrapper col-xs-12 col-sm-6">
                                { fieldInputs }
                                { activeBreakdownMessaging }
                            </div>
                            { showSumRadialGraphic ?
                                <div className="radial-indicator-wrapper col-xs-12 col-sm-6 pad-tp-sm text-center">
                                        <RadialIndicator
                                            innerWidthFunctionOfWidth={(width)=>(width*5/6)}
                                            containerId={'radial-indicator-autofit-container-' + setData.sectionCopy.index }
                                            outerFill={'transparent'}
                                            innerFill={ '#414141' }
                                            fillPercentsAndColors={ fillPercentsAndColors }
                                            fillerText={ formattingFunction(totalValue) }
                                            innerCircleClasses={ 'radial-indicator-inner' }
                                            pathClasses={ fillPercentsAndColors.length > 1 ?
                                                'radial-indicator-path-empty radial-indicator-path-category' :
                                                'radial-indicator-path-empty radial-indicator-path-category path-transition'}
                                            textClasses={ 'radial-indicator-text light-text' }
                                        />
                                </div> : ""
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DataSetSection.propTypes = {
    index: PropTypes.number.isRequired,
    setName: PropTypes.string.isRequired,
    setData: PropTypes.object.isRequired,
    breakdownIndicatorClickHandlerGenerator: PropTypes.func.isRequired,
    textInputChangeHandlerGenerator: PropTypes.func.isRequired,
    textInputBlurHandlerGenerator: PropTypes.func.isRequired,
    sliderInputChangeHandlerGenerator: PropTypes.func.isRequired,
    formattingFunction: PropTypes.func.isRequired,
    showSumRadialGraphic: PropTypes.bool.isRequired,
};

export default DataSetSection;